import React, { Fragment } from 'react';
import { CardBody, Card } from 'reactstrap';
import { Separator, Colxx } from '../../../../../../components/common/CustomBootstrap';

export default function Example({ url }) {
    return (
        <Card className="mt-4">
            <CardBody className="">
                <div className="text-center">
                    <h6> Example </h6>
                    <Separator className="mb-3" />
                    <Card className="m-4 p-4">
                        <Colxx xxs="12 " className="p-0">
                            <img
                                src={url}
                                alt="example"
                                width="auto"
                                className="img-thumbnail"
                            />
                        </Colxx>
                    </Card>
                </div>
            </CardBody>
        </Card>
    );
}
